import { formatEuro } from "@/helpers/CurrencyHelpers";
import { DashboardSignatureDayRow } from "@/interfaces/DashboardSignatureStats";
import { DateTime } from "luxon";
import { FC } from "react";
import { Card, Col, Row, Spinner, Table } from "react-bootstrap";

interface Props {
  rows: DashboardSignatureDayRow[];
  grandTotal: number;
  grandCount: number;
  month: number;
  year: number;
  isLoading?: boolean;
}

const DAY_LABELS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

const SignatureDayCalendarCard: FC<Props> = ({
  rows,
  grandTotal,
  grandCount,
  month,
  year,
  isLoading = false,
}) => {
  return (
    <Card className="h-100 shadow-none border">
      <Card.Body>
        <div className="mb-3">
          <h6 className="mb-0">Calendrier du mois</h6>
          <p className="text-muted fs--1 mb-0">
            Montant demandé sur les Dossiers signés, par jour
          </p>
        </div>

        {isLoading ? (
          <div className="text-center py-5">
            <Spinner />
          </div>
        ) : (
          <>
            <Row className="g-2 mb-3">
              <Col xs={6}>
                <div className="text-muted fs--1">Total</div>
                <div className="fs-3 fw-bold">{formatEuro(grandTotal)}</div>
              </Col>
              <Col xs={6}>
                <div className="text-muted fs--1">Nombre</div>
                <div className="fs-3 fw-bold">{grandCount}</div>
              </Col>
            </Row>

            <Table responsive size="sm" className="mb-0 fs--1">
              <thead>
                <tr>
                  <th>Jour</th>
                  <th className="text-end">Montant</th>
                  <th className="text-end">Nombre</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => {
                  const weekday = DateTime.fromObject({
                    year,
                    month,
                    day: row.day,
                  }).weekday;
                  const isWeekend = weekday >= 6;
                  return (
                    <tr
                      key={row.day}
                      className={isWeekend ? "bg-light" : undefined}
                    >
                      <td className={isWeekend ? "fw-semibold" : undefined}>
                        {DAY_LABELS[weekday - 1]} {row.day}
                      </td>
                      <td className="text-end">{formatEuro(row.total)}</td>
                      <td className="text-end">{row.count}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default SignatureDayCalendarCard;
